<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายงานขาย</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
                    <section class="d-flex justify-space-between">
                        <v-row class="mb-1">
                            <!-- วันที่เริ่มต้น -->
                            <v-col cols="12" sm="6" md="3" lg="2" xl="3" class="mt-4">
                                <v-text-field v-model="searchDateStart" label="วันที่เริ่มต้น" type="date"
                                    class="input-radius" color="#D6BFAF" outlined dense
                                    @change="checkDate"></v-text-field>
                            </v-col>

                            <!-- วันที่สิ้นสุด -->
                            <v-col cols="12" sm="6" md="3" lg="2" xl="3" class="mt-4">
                                <v-text-field v-model="searchDateEnd" label="วันที่สิ้นสุด" type="date"
                                    class="input-radius" color="#D6BFAF" outlined dense></v-text-field>
                            </v-col>

                            <!-- ปุ่ม Excel -->
                            <v-col cols="12" sm="12" md="1" lg="1" xl="1">
                                <v-btn color="success" @click="exportToExcel" class="mt-4">
                                    <v-icon left>mdi-microsoft-excel</v-icon>
                                    Excel
                                </v-btn>
                            </v-col>

                            <!-- spacer ดันช่องค้นหาไปขวาสุด -->
                            <v-spacer></v-spacer>

                            <!-- ช่องค้นหา -->
                            <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-text-field v-model="search" placeholder="ค้นหา..." append-icon="mdi-magnify"
                                    hide-details outlined dense class="input-radius mt-4"
                                    color="#D6BFAF"></v-text-field>
                            </v-col>
                        </v-row>

                    </section>

                    <section class="pa-3">
                        <v-data-table :headers="headers" :items="data_list" :search="search"
                            :footer-props="footer_Props" mobile-breakpoint="0">
                            <template v-slot:item="dataDetail">
                                <tr>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.round_count }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ dataDetail.item.time_open }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ formatPrice(dataDetail.item.total_amount) }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ (dataDetail.item.user_open) ? dataDetail.item.user_open
                                            :
                                            '-' }}</div>
                                    </td>
                                    <td>
                                        <div class="font-16">{{ (dataDetail.item.user_close) ? dataDetail.item.user_open
                                            :
                                            '-' }}</div>
                                    </td>
                                    <td>
                                        <div class="d-flex">
                                            <span>
                                                <v-btn elevation="2" class="my-3 mx-2 font-16" outlined color="#8EBBDC"
                                                    title="ดูรายงาน" style="border-radius:10px"
                                                    @click="link('/arin/pos/possalereportround/' + dataDetail.item.id)">
                                                    <v-icon>mdi-chart-line</v-icon> ดูรายงาน
                                                </v-btn>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_sale_report",
    data() {
        return {
            loading_page: false,
            dialog_cancel_order: false,
            search: '',
            searchDateStart: "",
            searchDateEnd: "",
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            headers: [
                {
                    text: 'รอบที่',
                    value: 'round_count',
                    fixed: true,
                    width: '160px'
                },
                {
                    text: 'ระยะเวลาการเปิดรอบ',
                    value: 'time_open',
                    fixed: true,
                    width: '150px'
                },
                {
                    text: 'ยอดขาย',
                    value: 'total_amount',
                    fixed: true,
                    width: '130px'
                },
                {
                    text: 'ผู้เปิดรอบ',
                    value: 'user_open',
                    fixed: true,
                    width: '200px'
                },
                {
                    text: 'ผู้ปิดรอบ',
                    value: 'user_close',
                    fixed: true,
                    width: '200px'
                },
                {
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    width: '120px'
                },
            ],

            data_list: [],
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'การขาย',
                    disabled: false,
                },
                {
                    text: 'รายงานขาย',
                    disabled: false,
                },
            ]
        }
    }, methods: {
        link(link) {
            window.location.href = link;
        },
        formatPrice(number) {
            return formatPrice(number)
        },
        async storeReportRound() {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            HTTP_ARIN.get('/pos/report/round/list', config).then((res) => {
                if (res.data.successful === true) {
                    this.data_list = res.data.data
                }
            })
        },
        checkDate() {
            // ถ้ากรอกวันที่ครบ 2 ช่องแล้ว ค่อยค้นหา
            if (this.searchDateStart  == '' || this.searchDateEnd  == '') {
                this.searchDate();
            }
        },

        async searchDate() {
            this.data_list = [];

            try {
                const res = await HTTP_ARIN.get("/pos/report/round/list", {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                    },
                    params: {
                        dateStart: this.searchDateStart,
                        dateEnd: this.searchDateEnd,
                    },
                });
                if (res.data.successful) {
                    this.data_list = res.data.data;
                }
            } catch (err) {
                console.error("Fetch by date failed:", err);
            } finally {
                this.loading_page = false;
            }
        },


        async exportToExcel() {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
                },
                params: {
                    dateStart: this.searchDateStart,
                    dateEnd: this.searchDateEnd,
                },
            };

            try {
                // เรียก GET เหมือน searchDate()
                const res = await HTTP_ARIN.get("/pos/report/round/list", config);
                if (!res.data.successful) {
                    throw new Error("Fetch failed");
                }

                // ดึง data มาทั้งหมด
                const allItems = res.data.data;

                // แปลงเป็น rawData ตามคอลัมน์ที่ต้องการ
                const rawData = allItems.map((item, idx) => ({
                    'ลำดับ': idx + 1,
                    'รอบที่': item.round_count,
                    'เวลาเปิด-ปิด': item.time_open,
                    'ยอดขาย': item.total_amount != null ? item.total_amount : "-",
                    'ผู้เปิดรอบ': item.user_open || "-",
                    'ผู้ปิดรอบ': item.user_close || "-",
                }));

                // สร้าง sheet + workbook
                const ws = XLSX.utils.json_to_sheet(rawData);
                ws['!cols'] = [
                    { wch: 6 },  // ลำดับ
                    { wch: 12 },  // รอบที่
                    { wch: 18 },  // เวลาเปิด-ปิด
                    { wch: 12 },  // ยอดขาย
                    { wch: 20 },  // ผู้เปิดรอบ
                    { wch: 20 },  // ผู้ปิดรอบ
                ];
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "รายงานขาย");

                // ชื่อไฟล์ตามช่วงวันหรือ All
                const filename = (this.searchDateStart && this.searchDateEnd)
                    ? `sales_report_${this.searchDateStart}_to_${this.searchDateEnd}.xlsx`
                    : `sales_report_All.xlsx`;

                // ดาวน์โหลดไฟล์
                XLSX.writeFile(wb, filename);

            } catch (err) {
                console.error("Export failed:", err);
                this.alert_message_error = "ไม่สามารถส่งออกข้อมูลได้";
                this.alert_error = true;
                setTimeout(() => (this.alert_error = false), 5000);
            }
        },

    },
    watch: {

        searchDateStart(val) {
            if (val && this.searchDateEnd) this.searchDate();
        },
        searchDateEnd(val) {
            if (val && this.searchDateStart) this.searchDate();
        },
    },
    mounted() {
        this.storeReportRound()
    }
}
</script>

<style scoped>
.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    /* width: 200px; */
}
</style>